import { PagedRequestType } from "../../../types/PagedResults";
import { SubscriptionStatisticsType } from "../../../types/Student";
import { get } from "../../../utils/axios-config";
import { SUBSCRIPTION_STATISTICS } from "../../../utils/constants";

export const getSubscriptionStatistics = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "100",
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear  } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse  } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject  } : {}),
         ...(data?.Semester ? { Semester: `${data.Semester}`  } : {}),
         ...(data?.Level ? { Level: `${data.Level}`  } : {}),
         ...(data?.Regime ? { Regime: `${data.Regime}`  } : {}),
    });
    const url = `${SUBSCRIPTION_STATISTICS}?${queryParams.toString()}`;
    return await get<SubscriptionStatisticsType[]>(url);
};